<div class="benefits" *ngIf="benefitsConfig$ | async as benefitsConfig">
    <div class="title" [innerHTML]="benefitsConfig.title"></div>
    <serviceos-web-benefits-list [texts]="texts" [benefits]="benefitsConfig.benefits"></serviceos-web-benefits-list>
</div>